import React from "react";
import {Box, Theme, Typography,} from "@mui/material";
import WarningIconRounded from "@mui/icons-material/WarningRounded";


export const ErrorScreen = () => {

  return (
      <Box>
          <WarningIconRounded/>
          <Typography align="left">
            Error
          </Typography>
          <Typography align="left">
            The provided URL is not valid.
          </Typography>
        </Box>
  );
};
